import makeRequest, {HttpMethod} from "./request";

const getUserEstablishmentsList = makeRequest('establishments-by-user').prepare(async (params: object) => {
    const { data, response, method } = params as { data: any; response: any, method: HttpMethod };

    let establishmentVoid = {
        id: '',
        label: 'Todos os estabelecimentos'
    };

    let establishments: { id: string; label: string }[] = [];

    if (Array.isArray(data?.data)) {

        establishments = data?.data?.map(({
                                              establishment_alias_id,
                                              description
                                          }: {
            establishment_alias_id: string;
            description: string
        }) => ({
            id: establishment_alias_id,
            label: description,
        }));

        // Ordena alfabeticamente (ignorando diferenças entre maiúsculas/minúsculas, mas mantendo acentos)
        establishments.sort((a, b) => a.label.localeCompare(b.label, 'pt-BR', { sensitivity: 'accent' }));
    }

    if(establishments.length != 1) {
        establishments = [establishmentVoid, ...establishments];
    }

    return {
        data: establishments,
        response,
        method
    };
});

export default getUserEstablishmentsList;